<!--
  - Copyright (c) 2020. Minerva Networks.
  - All rights reserved.
  -->

<template>
  <h1>Home</h1>
</template>

<script>
import {
  mapActions,
} from 'vuex';

export default {
  name: 'Home',
  props: {
  },

  mounted() {
    // this.loadTheHighlight();
  },
  methods: {
    ...mapActions(['loadTheHighlight'])
  },
};
</script>
